/* Help & FAQ page (section ff-faq-center): search that filters the questions, the topic links that follow your scroll,
   and opening the answer a link points to (…#question-handle). */
(() => {
  if (customElements.get('ff-faq')) return;

  const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '');

  class FFFaq extends HTMLElement {
    connectedCallback() {
      // an answer is found by its question, its text or its topic ("returns" finds everything under Returns)
      this.items = [...this.querySelectorAll('[data-ff-faq-item]')].map((el) => {
        const topic = el.closest('[data-ff-faq-group]')?.querySelector('.ff-faqc__h')?.textContent || '';
        return { el, text: norm(`${topic} ${el.textContent}`) };
      });
      this.groups = [...this.querySelectorAll('[data-ff-faq-group]')];
      this.links = [...this.querySelectorAll('[data-ff-faq-link]')];
      this.input = this.querySelector('[data-ff-faq-search]');
      this.status = this.querySelector('[data-ff-faq-status]');

      if (this.input) {
        let t;
        this.input.addEventListener('input', () => {
          clearTimeout(t);
          t = setTimeout(() => this.filter(this.input.value), 120);
        });
        this.input.form?.addEventListener('submit', (e) => e.preventDefault());
      }

      this.openHash = this.openHash.bind(this);
      window.addEventListener('hashchange', this.openHash);
      this.openHash();
      this.watchTopics();
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openHash);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    // every word has to appear in the question, its answer or its topic
    filter(query) {
      const words = norm(query).split(/\s+/).filter(Boolean);
      let shown = 0;
      this.items.forEach(({ el, text }) => {
        const hit = words.every((w) => text.includes(w));
        el.hidden = !hit;
        if (hit) shown += 1;
      });
      this.groups.forEach((g) => {
        g.hidden = !g.querySelector('[data-ff-faq-item]:not([hidden])');
      });
      // a short list of matches opens up, so the answers show without another tap
      const matches = this.items.filter(({ el }) => !el.hidden);
      if (words.length) matches.forEach(({ el }) => { el.open = matches.length <= 3; });
      this.toggleAttribute('data-searching', words.length > 0);
      if (!this.status) return;
      if (!words.length) this.status.textContent = '';
      else if (!shown) this.status.textContent = this.dataset.empty || '';
      else this.status.textContent = `${shown} ${shown === 1 ? 'answer' : 'answers'}`;
    }

    openHash() {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const el = document.getElementById(id);
      if (!el || !this.contains(el)) return;
      if (el.matches('details')) el.open = true;
      requestAnimationFrame(() => el.scrollIntoView({ block: 'start' }));
    }

    // the topic link for the group you're reading (the one at a line near the top of the screen) is marked as current
    watchTopics() {
      if (!this.links.length) return;
      const byId = new Map(this.links.map((a) => [a.getAttribute('href').slice(1), a]));
      let queued = false;
      const update = () => {
        queued = false;
        const line = Math.min(window.innerHeight * 0.25, 140);
        let current = null;
        for (const g of this.groups) {
          if (g.hidden || !g.id) continue;
          if (g.getBoundingClientRect().top <= line) current = g;
          else break;
        }
        const link = current && byId.get(current.id);
        this.links.forEach((a) => { if (a !== link) a.removeAttribute('aria-current'); });
        if (link) link.setAttribute('aria-current', 'true');
      };
      this.onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }
  }
  customElements.define('ff-faq', FFFaq);
})();
